export enum SITE_ROUTES {
	SITE_INFO = 'site-info',
	WIDGET = 'widget',
	SENSE_JS = 'sense-js'
}
